export default {
    STORE_SCORING_DATA(state, data) {
        state.scoringData = data;
    },

    STORE_SCORING_MATRIX_DATA(state, data) {
        state.scoringMatrixData = data;
    },
};
